import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  FormControl,
  TextField,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Controller } from "react-hook-form";

const FormTextField = ({
  sx,
  control,
  defaultValue,
  label,
  controllerName,
  type,
  size,
  placeholder,
  InputProps = {},
  disabled,
  InputLabelProps,
  margin,
  style,
  note,
  dynamicValue,
  onChange,
  showPasswordToggle = false, // New prop with default
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPasswordField = type === "password";

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <FormControl
      sx={
        Object.keys(style).length !== 0
          ? style
          : {
            display: "flex",
            flexDirection: "column",
            mt: "15px",
          }
      }
    >
      <Controller
        name={controllerName}
        control={control}
        defaultValue={dynamicValue ? dynamicValue : defaultValue}
        render={({
          field: { onChange: fieldOnChange, value, onBlur: fieldOnBlur },
          fieldState: { error },
        }) => (
          <TextField
            label={label}
            value={dynamicValue ? dynamicValue : value}
            onChange={(e) => {
              fieldOnChange(e);
              if (onChange) {
                onChange(e);
              }
            }}
            onBlur={() => {
              if (controllerName === "username") {
                fieldOnChange(value.trim());
              }
              fieldOnBlur();
            }}
            error={!!error}
            helperText={error ? error.message : note}
            type={
              isPasswordField && showPasswordToggle
                ? showPassword
                  ? "text"
                  : "password"
                : type
            }
            size={size}
            placeholder={placeholder}
            disabled={disabled}
            InputLabelProps={InputLabelProps}
            margin={margin}
            fullWidth
            fontSize={"0.5rem"}
            sx={sx}
            InputProps={{
              ...InputProps,
              endAdornment:
                isPasswordField && showPasswordToggle ? (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={togglePasswordVisibility}
                      edge="end"
                      aria-label="toggle password visibility"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ) : (
                  InputProps?.endAdornment || null
                ),
            }}
          />
        )}
      />
    </FormControl>
  );
};

FormTextField.propTypes = {
  label: PropTypes.string,
  controllerName: PropTypes.string,
  type: PropTypes.string,
  size: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  margin: PropTypes.string,
  style: PropTypes.object,
  note: PropTypes.string,
  InputProps: PropTypes.object,
  dynamicValue: PropTypes.any,
  onChange: PropTypes.func,
  showPasswordToggle: PropTypes.bool, // Added to prop types
};

FormTextField.defaultProps = {
  label: "",
  controllerName: "",
  type: "text",
  size: "medium",
  placeholder: "",
  disabled: false,
  margin: "",
  style: {},
  note: "",
  InputProps: {},
  showPasswordToggle: false,
};

export default FormTextField;
